'use client';

import { Spinner } from '@/components/atoms/Spinner';

export default function LoadingPage() {
  return (
    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
      <Spinner />
    </div>
  );
}
